export class EntityType {
    uuid: string;
    name: string;
    schema: Object;
    user_id: number;
    is_visible: boolean;
    ui_config: Object;
    kind: string;

    constructor(
        uuid: string = '',
        name: string = '',
        schema: Object = {},
        user_id: number = 0,
        is_visible: boolean = false,
        ui_config: Object = {},
        kind: string = null
    ) {
        this.uuid = uuid;
        this.name = name;
        this.schema = schema;
        this.user_id = user_id;
        this.is_visible = is_visible;
        if (ui_config === null) {
            ui_config = {'entity_editor': '', 'entity_viewer': '', 'entity_list_editor': '', 'entity_list_viewer': ''}; 
        }
        this.ui_config = ui_config;
        this.kind = kind;
    }
}

export class EntityInstance {
    uuid: string;
    entity_type_id: string;
    company_id: number;
    payload: Object;
    satisfies_schema: boolean;
    created: string;
    download_date: string;

    constructor(
        uuid: string = '',
        entity_type_id: string = '',
        company_id: number = 0,
        payload: Object = {},
        //satisfies_schema: boolean = false,
        created: string = new Date().toISOString(),
        download_date: string = ''
    ) {
        this.uuid = uuid;
        this.entity_type_id = entity_type_id;
        this.company_id = company_id;
        if (payload === null) {
            payload = {};
        }
        this.payload = payload;
        //this.satisfies_schema = satisfies_schema;
        this.created = created;
        this.download_date = download_date;
    }
}


export interface EntityTypeRepository {
    get_my_types(): Promise<any>;
    get_aux_workflow_editor_types(): Promise<any>;
    get_type_by_id(type_id: string, explicit:boolean): Promise<EntityType>;
    save(entity_type: EntityType): Promise<any>;
    create_empty_entity_type(): EntityType;
    get_UI_types(): Promise<EntityType[]>;
    get_available_UIs(type_id: string): Promise<any>;
}

export interface EntityInstanceRepository {
    get_instances_by_type(company_id:number, entity_type_id:string, filters:Array<Object>): Promise<any>;
    save(entity_instance: EntityInstance): Promise<any>;
    create_empty_entity_instance(company_id:number, entity_type:EntityType): EntityInstance;
    get_instance_by_id(instance_id: string): Promise<any>;
    delete_instances(instance_ids:string[]): Promise<void>;
    download_instances(instance_ids:string[]): Promise<any>;
}